import { render } from "./Reviews.vue?vue&type=template&id=536db5b5&scoped=true"
import script from "./Reviews.vue?vue&type=script&lang=js"
export * from "./Reviews.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=536db5b5&scoped=true&lang=css"
import "@/assets/css/styleSupport.css?vue&type=style&index=1&id=536db5b5&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536db5b5"]])

export default __exports__